export interface SchoolPluginEntryUrlsInterface {
  web?: string
  mobile?: string
}

export class SchoolPluginEntryUrls implements SchoolPluginEntryUrlsInterface {
  web?: string
  mobile?: string

  constructor(props: SchoolPluginEntryUrlsInterface) {
    const {
      // 重命名变量以规避与 JS 保留词的冲突, 比如 default, with
      web: _web,
      mobile: _mobile,
      // 可能会有额外字段比如自定义字段不在类型定义中
      ...rest
    } = props

    Object.assign(this, rest)

    this.web = _web
    this.mobile = _mobile
  }
}
